import "./Footer.css"

const Footer = () => {
    return(
        <section className="footer">
            <h4>&#169; JSBeedle 2021</h4>
            <a href='https://www.freepik.com/vectors/background'>Background vector created by rawpixel.com - www.freepik.com</a>
        </section>
    )
}

export default Footer